import React from 'react';
import { Text } from 'react-native';

const RegularText = ({
  children, isSemiBold, isBold, marginBottom = 10, textMaxWidth,
}) => (
  <Text style={{
    fontSize: 16,
    fontFamily: isBold ? 'Quicksand-bold' : (isSemiBold && 'Quicksand-Semibold'),
    marginBottom,
    width: textMaxWidth,
    overflow: textMaxWidth && 'hidden',
    whiteSpace: textMaxWidth && 'nowrap',
    textOverflow: textMaxWidth && 'ellipsis',
    wordWrap: textMaxWidth && 'break-word',
  }}
  >
    {children}
  </Text>
);
export default RegularText;
